module.exports = __webpack_public_path__ + "img/More1.52347f15.png";